import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { cx } from '../utils/cx';

export type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

const TONE_ICONS = {
  info: Info,
  success: CircleCheck,
  warning: TriangleAlert,
  danger: CircleAlert,
} as const;

export function ToneIcon({
  tone,
  className,
}: {
  tone: Exclude<Tone, 'neutral'>;
  className?: string;
}) {
  const Icon = TONE_ICONS[tone];
  return <Icon className={cx('av-icon', className)} aria-hidden="true" />;
}

export interface BadgeProps {
  tone?: Tone;
  /** Icône personnalisée ; par défaut, une icône associée au ton (sauf « neutral »). */
  icon?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Pastille d'état : toujours un libellé textuel, l'icône renforce la couleur. */
export function Badge({ tone = 'neutral', icon, children, className }: BadgeProps) {
  return (
    <span className={cx('av-badge', `av-badge--${tone}`, className)}>
      {icon ? (
        <span className="av-icon" aria-hidden="true">
          {icon}
        </span>
      ) : tone !== 'neutral' ? (
        <ToneIcon tone={tone} />
      ) : null}
      <span>{children}</span>
    </span>
  );
}
